module.exports = __webpack_public_path__ + "img/alteva.abd99e42.png";